export const selectRoutingHistory = (state: RootState) =>
  state.navigator.history || [];
